import { SexEnum } from '@uplift/types';
import { restClient } from '../../client';


export type InviteNewPatientInput = {
  first_name: string;
  last_name: string;
  email: string;
  birth_date?: string;
  sex?: SexEnum;
};


export type InviteNewPatientOutput =
  | {
    error: string;
    error_key: 'clientAlreadyHasAccount' | 'clientMatchedWithAnotherProvider';
    patient_id: string;
    match_uuid: '';
  }
  | {
    patient_id: string;
    match_uuid: string;
  };


export const inviteNewPatient = restClient.createRequest<InviteNewPatientInput, InviteNewPatientOutput>({
  url: '/auth/invite/patient',
  method: 'POST',
});
